import { FontSize14, Spacing4, Spacing8 } from 'autogen/design-tokens/tokens';
import useDropdown from 'components/dropdown/hooks/useDropdown';
import type { AnchorHTMLAttributes } from 'react';
import styled from 'styled-components';
import LinkAction from 'components/shared/Routing/components/LinkAction/LinkAction';
import type { LinkAction as LinkActionType } from 'components/shared/Routing/components/LinkAction/shared/types';

const Anchor = styled(LinkAction)`
    display: block;
    background: 0;
    border: 0;
    padding: ${Spacing4} ${Spacing8};
    font-size: ${FontSize14};
    text-transform: uppercase;
`;

export default function DropdownOption(
    props: { linkAction: LinkActionType } & AnchorHTMLAttributes<HTMLAnchorElement>
) {
    const { onClick, linkAction, ...restProps } = props;
    const { hide } = useDropdown();

    function handleOnClick(e) {
        if (onClick) {
            onClick(e);
        }
        hide();
    }

    return <Anchor onClick={handleOnClick} action={linkAction} {...restProps} />;
}
